import injectSheet from 'react-jss'
import Changelog from './Changelog'
import styles from './Changelog.styles'

export default injectSheet(styles)(Changelog)
